import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { TurnarDiligenciaService } from './turnar-diligencia.service';
import { of, Observable, combineLatest } from 'rxjs';
import { switchMap, filter, map, startWith } from 'rxjs/operators';
import {
    EvkResponseType,
    autocompleteEvkOption,
    EvkOption,
    MessageCrudService,
    EvkErrorType
} from '@evomatik/evk-common';
import { TurnarDiligenciaFormComponent } from '../diligencia-turnar-form/diligencia-turnar-form.component';
import { FormGroup } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-diligencia-turnar',
  templateUrl: './diligencia-turnar.component.html',
  styleUrls: ['./diligencia-turnar.component.scss']
})
export class DiligenciaTurnarComponent implements OnInit {
    form: FormGroup;
    unidadOptions$: Observable<EvkOption[]>;
    usuarioReceptorOptions$: Observable<EvkOption[]>;

    unidadFilter$: Observable<EvkOption[]>;
    usuarioFilter$: Observable<EvkOption[]>;

  constructor(
      public turnadoDiligenciaService: TurnarDiligenciaService,
      public messagesCrudService: MessageCrudService,
      public dialogRef: MatDialogRef<DiligenciaTurnarComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }
    ngOnInit(){

    }
    @ViewChild(TurnarDiligenciaFormComponent, {static: false})
    set formComponent(formComponent: TurnarDiligenciaFormComponent){
        formComponent.idConfig = this.data['idConfig'];
        formComponent.multipleTurnado = this.data['isTurnadoMultiple'];
        formComponent.getCatalogos();
        this.form = formComponent.form;
    }


    public get formValid() {
        return this.form !== undefined && this.form.valid;
    }
    private doneEdit(response: EvkResponseType) {
        // Se tiene que cerrar el dialog hasta que se guardó la transferencia.
        this.dialogRef.close(true);
    }
    protected errorEdit(error: EvkErrorType) {
        this.messagesCrudService.snackbarError(error);
    }
    public edit(): void {
            const dialog = this.messagesCrudService.openConfirmDialog({
                warn: '¿Está seguro de que desea turnar está diligencia?'
            });
            dialog.componentInstance.resolveEvent.subscribe((resolve: any) => {
                dialog.close();
                this.messagesCrudService.snackbarLoading();
                const tarea = Object.assign({}, this.data.data, this.form.value);
                tarea.usuarioAsignado = tarea.usuarioAsignado ? tarea.usuarioAsignado : null;
                of(tarea)
                    .pipe(
                        switchMap(this.turnadoDiligenciaService.evkOnBeforeEdit.bind(this.turnadoDiligenciaService)),
                        switchMap(this.turnadoDiligenciaService.edit.bind(this.turnadoDiligenciaService))
                    )
                    .subscribe(
                        this.doneEdit.bind(this),
                        this.errorEdit.bind(this)
                    );
            });
        }


}
